class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.loaded = false;
    this.onDrawerToggle = this.onDrawerToggle.bind(this);
    this.onViewportChange = this.onViewportChange.bind(this);
  }

  connectedCallback() {
    this.drawer = document.querySelector('cart-drawer');
    this.drawerDetails = this.drawer?.querySelector('details');

    if (this.drawerDetails) {
      this.drawerDetails.addEventListener('toggle', this.onDrawerToggle);
    }

    window.visualViewport?.addEventListener('resize', this.onViewportChange);
    window.addEventListener('resize', this.onViewportChange);
  }

  disconnectedCallback() {
    this.drawerDetails?.removeEventListener('toggle', this.onDrawerToggle);
    window.visualViewport?.removeEventListener('resize', this.onViewportChange);
    window.removeEventListener('resize', this.onViewportChange);
  }

  onViewportChange() {
    if (!document.body.classList.contains('mini-cart--open')) return;
    this.syncDrawerLayout();
  }

  onDrawerToggle() {
    if (!this.drawerDetails?.hasAttribute('open')) return;

    if (!this.loaded) {
      this.loadMiniCart();
      return;
    }

    this.syncDrawerLayout();
    document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
  }

  loadMiniCart() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const miniCart = document.getElementById('mini-cart');
        if (!miniCart) return;

        miniCart.innerHTML = this.getSectionInnerHTML(html, '.shopify-section');
        this.loaded = true;
        this.afterContentSwap();
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer?.querySelector('details');
    if (!detailsElement) return;

    if (detailsElement.hasAttribute('open')) {
      this.afterContentSwap();
      return;
    }

    this.drawer.openMenuDrawer();
    setTimeout(() => this.afterContentSwap(), 50);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections?.[section.id];
      if (!sectionHtml || !document.getElementById(section.id)) return;

      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(sectionHtml, section.selector);
    });

    this.loaded = true;
    document.dispatchEvent(new CustomEvent('cartdrawer:content-updated'));

    if (typeof setHeaderBottomPosition === 'function') {
      setHeaderBottomPosition();
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.open();
      });
    });
  }

  afterContentSwap() {
    if (typeof setHeaderBottomPosition === 'function') {
      setHeaderBottomPosition();
    }

    this.syncDrawerLayout();

    requestAnimationFrame(() => {
      this.syncDrawerLayout();
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
    });
  }

  syncDrawerLayout() {
    const drawer = document.getElementById('mini-cart');
    if (!drawer) return;

    const viewportHeight = Math.round(window.visualViewport?.height ?? window.innerHeight);
    drawer.style.setProperty('--max-height', `${viewportHeight}px`);
    drawer.style.height = `${viewportHeight}px`;
    drawer.style.minHeight = `${viewportHeight}px`;
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
